import React from "react";

interface IconProps {
  isActive?: boolean;
}

const DashboardIcon: React.FC<IconProps> = ({ isActive = false }) => (
  <svg
    width="20"
    height="20"
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    className="w-[20px] h-[20px]"
  >
    <g clipPath="url(#clip0_2019_1687)">
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M6.73884 8.101H3.15652C2.63088 8.09689 2.12504 8.29132 1.75028 8.64148C1.37552 8.99164 1.16254 9.46888 1.1582 9.9682V17.035C1.16793 18.0744 2.06242 18.9098 3.15652 18.901H6.73884C7.26444 18.9052 7.77033 18.7108 8.14511 18.3606C8.51989 18.0105 8.73286 17.5332 8.73715 17.0338V9.9682C8.73286 9.46888 8.51989 8.99164 8.14511 8.64148C7.77033 8.29132 7.26444 8.09689 6.73884 8.101Z"
        stroke={isActive ? "#85BDFF" : "white"}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      ></path>
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M6.73884 0.901115H3.15652C2.08443 0.872867 1.19053 1.6743 1.1582 2.69272V3.90952C1.19053 4.92794 2.08443 5.72938 3.15652 5.70112H6.73884C7.81088 5.72938 8.70481 4.92794 8.73715 3.90952V2.69272C8.70481 1.6743 7.81088 0.872867 6.73884 0.901115Z"
        stroke={isActive ? "#85BDFF" : "white"}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      ></path>
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M13.2618 11.7012H16.8428C17.3687 11.7057 17.8748 11.5114 18.2499 11.1612C18.6249 10.811 18.8381 10.3336 18.8424 9.83404V2.76839C18.8381 2.26904 18.6252 1.79178 18.2504 1.44161C17.8756 1.09144 17.3697 0.897035 16.8441 0.901187H13.2618C12.7362 0.897035 12.2303 1.09144 11.8555 1.44161C11.4807 1.79178 11.2678 2.26904 11.2635 2.76839V9.83404C11.2678 10.3334 11.4807 10.8106 11.8555 11.1608C12.2303 11.5109 12.7362 11.7053 13.2618 11.7012Z"
        stroke={isActive ? "#85BDFF" : "white"}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      ></path>
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M13.2618 18.9011H16.8428C17.9154 18.93 18.8101 18.1284 18.8424 17.1095V15.8927C18.8101 14.8743 17.9161 14.0729 16.8441 14.1011H13.2618C12.1897 14.0729 11.2958 14.8743 11.2635 15.8927V17.1083C11.295 18.1272 12.1892 18.9293 13.2618 18.9011Z"
        stroke={isActive ? "#85BDFF" : "white"}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      ></path>
    </g>
    <defs>
      <clipPath id="clip0_2019_1687">
        <rect width="20" height="20" fill="white"></rect>
      </clipPath>
    </defs>
  </svg>
);

export default DashboardIcon;
